import React from 'react';

import { WizardFormError } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-error/wizard-form-error';
import { WizardFormErrors } from '@futrli/ui-components/components/sidebar/wizard/types';
import { WizardFormValidationErrorSummary } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-validation-error-summary/wizard-form-validation-error-summary';

import { DriverControlBar } from '../../../non-financial-drivers/components/driver-control-bar/driver-control-bar';
import { InputMethod } from '../types';
import { NonFinancialDriverTreeNode } from '../../../non-financial-drivers/types';

interface DataBuilderFormContainerProps {
  addToGroup?: string;
  children?: React.ReactNode;
  decimalDisplay?: string;
  groups?: NonFinancialDriverTreeNode[];
  errors?: WizardFormErrors;
  inputMethod?: InputMethod;
  isAddingNew?: boolean;
  isSaving?: boolean;
  name?: string;
  onAddToGroupChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDecimalDisplayChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFieldBlur?: () => void;
  onInputMethodChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onNameChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  saveError?: boolean;
}

export const DataBuilderFormContainer = ({
  addToGroup,
  children,
  decimalDisplay,
  groups,
  errors,
  inputMethod,
  isAddingNew,
  isSaving,
  name,
  onAddToGroupChange,
  onDecimalDisplayChange,
  onFieldBlur,
  onInputMethodChange,
  onNameChange,
  saveError
}: DataBuilderFormContainerProps) => {
  return (
    <>
      {saveError && <WizardFormError mb={3} />}
      <WizardFormValidationErrorSummary errors={errors} mb={3} />

      <DriverControlBar
        addToGroup={addToGroup}
        decimalDisplay={decimalDisplay}
        errors={errors}
        groups={groups}
        inputMethod={inputMethod}
        isAddingNew={isAddingNew}
        isDisabled={isSaving}
        name={name}
        onAddToGroupChange={onAddToGroupChange}
        onDecimalDisplayChange={onDecimalDisplayChange}
        onFieldBlur={onFieldBlur}
        onInputMethodChange={onInputMethodChange}
        onNameChange={onNameChange}
      />
      <div
        style={{
          padding: '20px',
          background: '#fff',
          border: '1px solid var(--colorsUtilityMajor075)',
          borderRadius: '8px'
        }}
      >
        {children}
      </div>
    </>
  );
};
